<template>
  <div
    :style="{
      padding: '0px',
      margin: '14px',
      minHeight: '100px',
    }"
  >
    <a-row>
      <a-col :span="16">
        <div
          :style="{
            padding: '',
            margin: '24px 0px 24px 0',
            minHeight: '100px',
          }"
        >
          <a-row>
            <a-col :span="12">
              <div
                class="cardone"
                :style="{
                  background: '#fff',
                  minHeight: '100px',
                  padding: '0 10px',
                }"
              >
                <p class="text3">数据统计</p>
                <a-divider />
                <a-row>
                  <a-col :span="12">
                    <div
                      class=""
                      :style="{
                        background: '#f5f5f5',
                        minHeight: '110px',
                        padding: '10px',
                      }"
                    >
                      <p>会员统计</p>
                      <h1 style="color: #000">{{ huiyuan }}</h1>
                      <p>当前注册的会员数量</p>
                    </div>
                  </a-col>
                  <a-col :span="12">
                    <div
                      :style="{
                        margin: '0 0 0 8px',
                        background: '#f5f5f5',
                        minHeight: '110px',
                        padding: '10px',
                      }"
                    >
                      <p>门店统计</p>
                      <h1>{{ mendian }}</h1>
                      <p>当前的门店数量</p>
                    </div>
                  </a-col>
                </a-row>
              </div>
            </a-col>
            <a-col :span="12">
              <div
                class="cardtwo"
                :style="{
                  margin: '0 0px 0 14px',
                  background: '#fff',
                  minHeight: '100px',
                  padding: '0 10px',
                }"
              >
                <p class="text3">快速导航</p>
                <a-divider />
                <a-row>
                  <a-col :span="8">
                    <div
                      :style="{
                        background: '#f5f5f5',
                        minHeight: '80px',
                      }"
                    >
                      <h1 class="text">{{ currencyTotal }}</h1>
                    </div>
                    <p class="text1">代币套餐订单</p>
                  </a-col>
                  <a-col :span="8">
                    <div
                      :style="{
                        margin: '0 0 0 10px',
                        background: '#f5f5f5',
                        minHeight: '80px',
                      }"
                    >
                      <h1 class="text">{{ ticketsTotal }}</h1>
                    </div>
                    <p class="text1">门票套餐订单</p>
                  </a-col>
                  <a-col :span="8">
                    <div
                      :style="{
                        margin: '0 0 0 8px',
                        background: '#f5f5f5',
                        minHeight: '80px',
                      }"
                    >
                      <h1 class="text">{{ orderTotal }}</h1>
                    </div>
                    <p class="text1">已支付订单</p>
                  </a-col>
                </a-row>
              </div>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <home-echatrs> </home-echatrs>
            </a-col>
          </a-row>
        </div>
      </a-col>
      <a-col :span="8">
        <div
          class="zhanneixin"
          :style="{
            padding: '24px',
            margin: '24px 0 24px 14px',
            background: '#fff',
            minHeight: '100px',
          }"
        >
          <h1 style="font-size: 16px">站内信</h1>

          <a-divider />
          <!--
          <a-row>
            <a-col :span="8"> 订单支付 </a-col>
            <a-col :span="4"> <a-badge count="未读" /> </a-col>
            <a-col :span="12"> 2021-3-14 00:00:00 </a-col>
          </a-row>
          <a-row>
            <a-col :span="8"> 订单支付 </a-col>
            <a-col :span="4">
              <a-badge
                count="已读"
                :number-style="{ backgroundColor: '#52c41a' }"
              />
            </a-col>
            <a-col :span="12"> 2021-3-14 00:00:00 </a-col>
          </a-row> -->
          <a-modal v-model="visible" title="消息" @ok="handleOk">
            <p>{{ mes }}</p>
          </a-modal>
          <a-table
            @change="handleTableChange"
            :columns="columns"
            :data-source="data"
            :showHeader="false"
            :pagination="pagination"
            :loading="loading"
          >
            <template slot="messageType" slot-scope="text, messageType">
              <a-tag
                v-if="messageType.readed === true"
                @click="message(messageType)"
                color="#87d068"
              >
                已读
              </a-tag>
              <a-tag @click="message(messageType)" v-else color="#f50">
                未读
              </a-tag>
            </template>
          </a-table>
        </div>
        <div
          class="xitong"
          :style="{
            padding: '24px',
            margin: '24px 0 24px 14px',
            background: '#fff',
            minHeight: '100px',
          }"
        >
          <p class="p">系统消息</p>

          <a-divider />
          <systemInformationForm></systemInformationForm>
        </div>
        <div></div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import {
  mainStatistical,
  mainVipStatistical,
  mainTablelInfo,
  mainTableTwolInfo,
  count_order,
  yidu,
} from "@/api/homeApi.js";
import { message } from "ant-design-vue";
import systemInformationForm from "./systemInformationForm.vue";
import homeEchatrs from "./homeEchatrs.vue";
const columns = [
  {
    title: "ma",
    dataIndex: "messageTitle",
    scopedSlots: { customRender: "name" },
  },
  {
    dataIndex: "readed",
    scopedSlots: { customRender: "messageType" },
  },
  {
    dataIndex: "createTime",
    scopedSlots: { customRender: "createTime" },
  },
];

const data = [
  {
    key: "1",
    name: "John Brown",
    age: 32,
    address: "New York No. 1 Lake Park",
    tags: ["nice", "developer"],
  },
  {
    key: "2",
    name: "Jim Green",
    age: 42,
    address: "London No. 1 Lake Park",
    tags: ["loser"],
  },
  {
    key: "3",
    name: "Joe Black",
    age: 32,
    address: "Sidney No. 1 Lake Park",
    tags: ["cool", "teacher"],
  },
];
export default {
  components: {
    systemInformationForm,
    homeEchatrs,
  },
  data() {
    return {
      visible: false,
      mes: "",
      readed: "",
      objId: "",
      data: {},
      columns,
      mendian: "",
      huiyuan: "",
      ticketsTotal: "",
      orderTotal: "",
      currencyTotal: "",
      pagination: {
        current: 1,
        total: 0,
        pageSizeOptions: ["10", "20", "40", "80"],
        pageSize: 5,
      },
      loading: false
    };
  },
  mounted() {
    this.getMainStatistical();
    this.getMainVipStatistical();
    this.getMainTablelInfo();
    this.getMainTableTwolInfo();
  },
  methods: {
    aaa(row) {
      console.log(row);
    },
    message(row) {
      this.visible = true;
      this.mes = row.messageRecord;
      this.readed = row.readed;
      this.objId = row.objId;
      this.console.log(row);
    },
    rowSelection(value) {
      console.log(value);
    },
    // 门店统计
    getMainStatistical() {
      mainStatistical().then((res) => {
        this.mendian = res.data;
      });
      count_order().then((res) => {
        this.currencyTotal = res.data.currencyTotal;
        this.orderTotal = res.data.orderTotal;
        this.ticketsTotal = res.data.ticketsTotal;
        console.log(" this.gg------------------------", res);
      });
    },
    getMainVipStatistical() {
      mainVipStatistical().then((res) => {
        this.huiyuan = res.data;
      });
    },
    getMainTablelInfo() {
      mainTablelInfo(10, 1).then((res) => {
        // sessionStorage.setItem("data", JSON.stringify(res.data));
      });
    },
    getMainTableTwolInfo() {
      mainTableTwolInfo(5, 1).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      mainTableTwolInfo(5, this.pagination.current).then((res) => {
        this.data = res.data;
        this.loading = false;
      });
    },
    handleOk() {
      this.visible = false;
      yidu(this.objId).then((res) => {
        this.getMainTableTwolInfo();
        message.success("已读消息");
      });
    },
  },
};
</script>

<style>
.xitong {
  height: 393px;
}

.cardone {
  height: 236px;
}

.cardtwo {
  height: 236px;
}

.text {
  line-height: 80px;
  text-align: center;
}

.text1 {
  font-weight: 500;
  color: #000;
  font-size: 16px;
  text-align: center;
}

h1 {
  font-size: 28px;
  color: #666666;
}

.text3 {
  position: relative;
  top: 10px;
  color: #000;
  font-size: 16px;
}

.p {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/homeContent.vue